// removed by extract-text-webpack-plugin
module.exports = {"authModal":"_1qg_7","closeButton":"_3bXA6"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AuthModal/index.sass
// module id = 1460
// module chunks = 1